import { render, staticRenderFns } from "./accountForm.vue?vue&type=template&id=80409868&scoped=true&"
import script from "./accountForm.vue?vue&type=script&lang=js&"
export * from "./accountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80409868",
  null
  
)

export default component.exports